import { render, staticRenderFns } from "./radiologyreport.vue?vue&type=template&id=03b035c6&"
import script from "./radiologyreport.vue?vue&type=script&lang=js&"
export * from "./radiologyreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports